import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SvgCalendar from '@material-ui/icons/DateRange';
import SvgFile from '@material-ui/icons/InsertDriveFileOutlined';

import {helper} from '../../common/common';

const styles = (theme) => {
    return {
        panel: {
            position: 'relative',
            marginTop: 8,
            marginBottom: 29,
            marginLeft: 16,
            marginRight: 16,
            height: 98,
            textAlign: 'left',
        },
        textLabel: {
            display: 'inline-block',
            marginLeft: 4,
            fontSize: 12,
            fontWeight: 300,
            verticalAlign: 'middle',
        },
        labelIcon: {
            ...theme.iconStyle.size[16],
            ...theme.iconStyle.dark,
            display: 'inline-block',
            marginBottom: 3,
            verticalAlign: 'middle',
        },
        nameLabel: {
            paddingTop: 8,
            paddingLeft: 16,
            paddingRight: 16,
            fontSize: 18,
            fontWeight: 500,
            fontVariant: 'small-caps',
        },
        dateLabel: {
            paddingTop: 4,
            paddingLeft: 16,
            paddingRight: 16,
            width: 160,
            display:'inline-block',
        },
        fileLabel: {
            paddingTop: 4,
            paddingLeft: 16,
            paddingRight: 16,
            display:'inline-block',
            textTransform: 'lowercase',
        },
        description: {
            paddingTop: 12,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 8,
            fontSize: 13,
            fontWeight: 300,
            fontStyle: 'italic',
        },
        downloadLabel: {
            position: 'absolute',
            height: 26,
            lineHeight: '26px',
            top: 9,
            right: 16,
            fontSize: 13,
            verticalAlign: 'middle',
            color: theme.palette.secondary.main,
            cursor: 'pointer',
            textTransform: 'uppercase',
        },
    }
}

class Card extends Component {
    render = () => {
        const {classes} = this.props;

        return (
            <Paper
                className={classes.panel}
                square={false}
                elevation={2}
            >
                <Typography
                    className={classes.nameLabel}
                    align='left'
                >
                    {this.props.info.name}
                </Typography>
                <Typography
                    className={classes.downloadLabel}
                    align='left'
                    onClick={this._handleDownload}
                >
                    Download
                </Typography>
                <div className={classes.dateLabel}>
                    <SvgCalendar className={classes.labelIcon}/>
                    <Typography
                        className={classes.textLabel}
                        align='left'
                    >
                        {helper.makeDate(this.props.info.date)}
                    </Typography>
                </div>
                <div className={classes.fileLabel}>
                    <SvgFile className={classes.labelIcon}/>
                    <Typography
                        className={classes.textLabel}
                        align='left'
                    >
                        {this.props.info.file_type ? this.props.info.file_type : 'unknown'}
                    </Typography>
                </div>
                <Typography
                    className={classes.description}
                    align='left'
                >
                    {this.props.info.desc ? this.props.info.desc : '*No description*'}
                </Typography>
            </Paper>
        );
    }

    _handleDownload = () => {
        if (this.props.onDownload) {
            this.props.onDownload(this.props.info)
        }
    }
}

Card.propTypes = {
    info: PropTypes.object.isRequired,
    onDownload: PropTypes.func,
}

export default withStyles(styles)(Card);
